/**
 * The root component. All other states are injected based on routing in this components
 * router-outlet. Global componenets (agency select, header, footer) declared here.
 */

// ng
import { Component, ViewEncapsulation, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

// ext
import { Subscription } from 'rxjs';
import { upperFirst } from 'lodash';

// local
import { env } from 'src/env/development';
import { cloneDeep } from 'lodash';
import { SpinnerOverlayService } from 'src/app/services/spinnerOverlay.service';
import { CoreService, AccessLevel, UserTypeCode } from 'src/app/services/core.service';
import Plan from 'src/app/models/plan';
import EnrollmentPeriod from 'src/app/models/enrollmentPeriod';
import * as dayjs from 'dayjs';
import Subscriber from 'src/app/models/subscriber';

@Component({
  selector: 'plan-selection',
  templateUrl: 'planSelection.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class PlanSelectionComponent implements OnInit, OnChanges, OnDestroy {
  @Input() availablePlans: Plan[];
  @Input() planType: string;
  @Input() selectedPlan: Plan;
  @Input() subscriber: Subscriber;
  @Input() isWaived = false;
  @Input() readonly = false;
  @Input() selectedPlanId: string[] = [];
  @Input() subscriberOrDependentsHaveMedicareB = false;
  @Input() memberTypeCode: string;
  @Input() medicareDEnabled = false;
  @Input() isRetireeOrCOBRA = false;
  @Input() enrollmentPeriod: EnrollmentPeriod;
  @Output() updateSelectedPlan: EventEmitter<Plan> = new EventEmitter<Plan>();
  @Output() removeSelectedPlan: EventEmitter<Plan> = new EventEmitter<Plan>();
  @Output() getPlans: EventEmitter<boolean> = new EventEmitter<boolean>();
  availablePlanColumns = [];
  availablePlanClone: Plan[];
  showAll = false;
  isHCAEditOrAdmin = false;
  isPebb: boolean;
  coverageYear: number;
  isNewlyEligible = false;
  planNameYearlyOverrides = { 2025: {
    'T1': 'Davis Vision by MetLife, underwritten by Metropolitan Life Insurance Company (MetLife)'
  }};

  constructor(
    private coreService: CoreService
  ) {}

  ngOnInit(): void {
    this.isHCAEditOrAdmin = this.coreService.systemUserHasAccess(AccessLevel.Edit, UserTypeCode.HCA);
    this.availablePlanColumns = [
      {
        field: 'planName',
        title: upperFirst(this.planType) + ' plan',
        format: 'text',
        // value: (row, originalValue) => ((this.medicareDEnabled && this.subscriberOrDependentsHaveMedicareB) ? row.medicareDPlanName : originalValue) ?? originalValue
        value: (row, originalValue) => (this.medicareDEnabled && this.isRetireeOrCOBRA && row.medicareDPlanName) ? `${originalValue} or ${row.medicareDPlanName}` : originalValue
      },
      {
        field: 'rateAmt',
        title: 'Premium',
        format: 'c0'
      }
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enrollmentPeriod?.isFirstChange) {
      this.coverageYear = dayjs(this.enrollmentPeriod.coverageEffectiveStartDate).year();
      this.isNewlyEligible = this.enrollmentPeriod.enrollmentPeriodType.enrollmentPeriodTypeCode === 'NE';
    }

    if (changes.subscriber?.isFirstChange)
      this.isPebb = !this.subscriber.isSebb && !this.subscriber.isSelfPay;

    if (changes.availablePlans?.isFirstChange) {
      this.availablePlanClone = cloneDeep(this.availablePlans).map(p => {
        p.planName = (this.planNameYearlyOverrides[this.coverageYear] && this.planNameYearlyOverrides[this.coverageYear][p.planCode]) ?? p.planName;
        return p;
      });
    }
  }

  ngOnDestroy(): void {
  }

  onPlanSelected(selectedPlan: Plan): void {
    this.updateSelectedPlan.emit(selectedPlan);
  }

  showAllChange(): void {
    this.getPlans.emit(this.showAll);
  }

  onPlanDeSelected(selectedPlan: Plan): void {
    this.removeSelectedPlan.emit(selectedPlan);
  }
}